import filterLodash from 'lodash/filter'

class Filter {
    constructor(filters) {
        this.filters = {};
        this.from_slug = [];

        for (let key in filters) {
            let filter = filters[key];
            if (Array.isArray(filter.value)) {
                for (let key in filter.value) {
                    let value = filter.value[key];
                    if (value !== undefined) {
                        this.addFilter(filter.name, value);
                    }
                }
            } else {
                if (filter.value !== undefined) {
                    this.addFilter(filter.name, filter.value);
                    if (filter.from_slug) {
                        this.from_slug.push(filter.name);
                    }
                }
            }
        }
    }

    getFilters() {
        return this.filters;
    }

    getFilter(name) {
        return this.filters[name];
    }

    addFilter(name, value) {
        if ((typeof value === "string") === false) {
            console.error(`Only strings allowed to add as filter (${name})`);
            return this;
        }

        let currentValue = this.filters[name];

        if (Array.isArray(currentValue)) {
            if (currentValue.hasOwnProperty(value) === false) {
                currentValue.push(value);
            }
        } else {
            currentValue = [currentValue, value];
        }

        this.setFilter(name, currentValue);

        return this;
    }

    isEmpty() {
        return Object.keys(this.filters).length <= 0;
    }

    count() {
        return Object.keys(this.filters).length;
    }

    hasFilter(name) {
        return this.filters.hasOwnProperty(name);
    }

    hasFilterWithValue(name, value) {
        if (this.hasFilter(name)) {
            let filterValue = this.getFilter(name);

            if (Array.isArray(filterValue)) {
                return filterValue.includes(value);
            }

            return filterValue === value;
        }

        return false;
    }

    removeFilterWithValue(name, value) {
        if (this.hasFilterWithValue(name, value)) {
            let filter = this.getFilter(name);

            if (Array.isArray(filter)) {
                filter = filterLodash(filter, (item) => value !== item);
            }

            if (filter.length >= 1) {
                this.setFilter(name, filter)
            } else {
                this.removeFilter(name);
            }
        }

        return this;
    }

    removeFilter(name) {
        if (this.hasFilter(name)) {
            delete this.filters[name];
        }
    }

    setFilter(name, value) {
        this.filters[name] = filterLodash(value, (item) => undefined !== item);
        return this;
    }

    toUrlString(page = null, additionalFilters = null, rawFilter = false) {
        let params = this.getFilters();
        let url = '';

        if (additionalFilters && typeof additionalFilters === 'object') {
            params = {...params, ...additionalFilters};
        }

        if (!rawFilter) {
            params = Object.keys(params)
                .filter((key) => {
                    return !this.from_slug.includes(key);
                })
                .reduce((obj, key) => {
                    obj[key] = params[key];
                    return obj;
                }, {});
        }

        url += Object.keys(params).map((key) => {
            let string = '';
            if (Array.isArray(params[key])) {
                for (let i = 0; i < params[key].length; i++) {
                    let value = params[key][i];
                    string += encodeURIComponent(key) + '[]=' + value;

                    if (params[key].length !== i + 1) {
                        string += '&';
                    }
                }
            } else {
                string += encodeURIComponent(key) + '=' + params[key];
            }
            return string;
        }).join('&');

        if (url !== '' && url.includes('?') === false) {
            url = `?` + url;
        }

        if (page !== null) {
            url += (url.includes("?") ? '&' : '?') + `page=${page}`;
        }
        return url;
    }

    toRawUrlString(page = null, additionalFilters = null) {
        return this.toUrlString(page, additionalFilters, true);
    }
}

export default Filter;


